const LAYER = [
  '',
  '',
  '',
  '',
  'menu',
  'header',
  'footer',
  'floatingButton',
  'modal',
  'tooltip',
  'loading',
]

function getLayer(name: string) {
  return LAYER.indexOf(name)
}

export default getLayer
